// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kKhs","tabsBox":"styles_tabsBox__Eum0d","createButton":"styles_createButton__20nZC"};